import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import phoneicon from '../../public/img/phone.png';

class ContactHeader extends PreLoginPage {
    constructor(props) {
        super(props);
    };
    render() {

        return (
            <div id="ContactHeader">
                <div className="">			
                    {/* <div className="row">
                        <div className="col-12 contact-head">                         */}
                            <span className="contactbtn" onClick={this.props.showContactus}>Contact us</span>
                            <span><i class="material-icons">local_phone</i></span>
                            {/* <img src={phoneicon} style={{margin:'5px',borderRadius:'30px 30px 30px 30px',background:this.props.background || "transparent"}}></img> */}
                            {/* <img src={phoneicon} style={{margin:'5px',padding:"5px",border:"2px solid white",borderRadius:'30px 30px 30px 30px',background:this.props.background || "transparent"}}></img> */}
                            <span className="contactbtn" >9884400755</span>
                        </div>
                    </div>
            //     </div>
            // </div>
        )
    }
  }
  
  export default ContactHeader;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/ContactHeader.js